import { Calendar } from "lucide-react";

import { CalendarCardProps } from "../types";
import BaseBadge from "@/components_v2/Badge/BaseBadge";
import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";

const CalendarCard = ({
  date,
  title,
  description,
  tag,
  linkUrl,
  linkLabel,
}: CalendarCardProps) => {
  return (
    <div className="guidance-page-calendar-card flex">
      <div className="guidance-page-calendar-card-date flex items-center gap-200">
        <Calendar size={24} className="flex-shrink-0" />

        <span className="guidance-page-calendar-card-date-text body-m-medium">
          {date}
        </span>
      </div>

      <div className="guidance-page-calendar-card-content flex flex-col gap-200 flex-1">
        <div className="flex items-center gap-200 flex-wrap">
          <h3 className="guidance-page-calendar-card-title body-m-medium">
            {title}
          </h3>

          {tag != null && tag !== "" && (
            <BaseBadge
              children={tag}
              backgroundColor="var(--orange-500-10)"
              fontColor="var(--orange-700)"
            />
          )}
        </div>

        <p className="guidance-page-section-description body-m-regular">
          {description}
        </p>

        {linkUrl != null && linkUrl !== "" && linkLabel != null && (
          <BaseButton
            variant={BUTTON_VARIANTS.SECONDARY}
            size={BUTTON_SIZES.SMALL}
            onClick={() =>
              window.open(linkUrl, "_blank", "noopener,noreferrer")
            }
          >
            {linkLabel}
          </BaseButton>
        )}
      </div>
    </div>
  );
};

export default CalendarCard;
